import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    lastQuery: null,
    promotionList: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },

    promotionList: state => {
        return state.promotionList;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        console.log('setfilters');
        state.filters = filters;
    },

    [type.SET_PROMOTION_LIST](state, promotionList) {
        state.promotionList = promotionList;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.promotion.search.meta',
        );

        startLoading(dispatch, 'get-promotion-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-promotion-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-promotion-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getPromotionList({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 50,
                    maxprice: 1,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-promotion');

        let api = Laroute.route('franchise.vue.get.promotions');

        return axios
            .get(api, options)
            .then(res => {
                let data = res.data.data;

                commit('setLastQuery', params.query);
                commit(type.SET_PROMOTION_LIST, data);
                endLoading(dispatch, 'fetch-promotion');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-promotion');
                throw err;
            });
    },

    getPromotionListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.promotionList.length || state.lastQuery !== params.query) {
            return dispatch('getPromotionList', params);
        }

        return Promise.resolve(state.promotionList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
